module.exports = __webpack_public_path__ + "static/media/instagram-icon.3d5d10b8.svg";